import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const Wrapper = styled(Box)(`
  width:1080px;
  max-height: calc(100vh - 200px);
`)

export const TitleWrapper = styled(Box)(`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
`)

export const WidgetOuterWrapper = styled(Box)( props => `
  height: calc(100vh - 300px);
  width: 100%;
  overflow-y: scroll;
  border: 1px #d3d3d3 solid;
  `)
  
export const WidgetWrapper = styled(Box)( props => `
  padding: 32px 12px 32px 32px;
  width: 100%;
  position: relative;
  min-height: 150px;
  display: grid;
  grid-auto-flow: dense; /* auto-place spanned items */

  & .colsLegend {
    width:calc(100% - 72px);
    height: 20px;
    overflow:hidden;
    position: absolute;
    left: 36px;
    top: 0;

    &:before {
      content: 'ABCD';
      width: 100%;
      height: 20px;
      font-size: 12px;
      line-height: 25px;
      letter-spacing: 245px;
      text-align: center;
      margin-left: 122px;
    }
  }

  & .rowsLegend {
    line-height: 79px;
    // height: 100%;
    position: absolute;
    left: 10px;
    top: 35px;
    font-size: 12px;
    text-align: center;
    letter-spacing: 0;
    text-align: left;
    width: 18px;

    & hr {
      height: 1px;
      background: #333;
      position: absolute;
      left: 0;
      margin-top: -4px;
      width: 1060px;
      left: -10px;
      background-color: #095BBD;
      z-index:1;
      border: 0;
    }

    // & hr:first-of-type {display: none;}
  }

`)

export const ActionWrapper = styled(Box)(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  & button {
    margin: 0 !important;
  }
`)

export const PrintBreak = styled(Box)(`
  display: flex;
  font-size: 12px;
  
  &:before {
    content: '';
    width: 20px;
    border: 2px #095BBD solid;
    margin-right: 10px;
    height: 0;
    display: flex;
    align-items: center;
    margin-top: 7px;
  }
`)

